import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { DataProvider } from "./contexts/DataContext";
import { initGA } from "./utils/analytics";
import { usePageTracking } from "./hooks/useAnalytics";
import Home from "./components/Home";
import Alphabets from "./components/Alphabets";
import Words from "./components/Words";
import Sentences from "./components/Sentences";
import FloatingTutorButton from "./components/FloatingTutorButton";

// Component to handle page tracking
function AppContent() {
  usePageTracking();

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/alphabets" element={<Alphabets />} />
        <Route path="/words" element={<Words />} />
        <Route path="/sentences" element={<Sentences />} />
      </Routes>
      <FloatingTutorButton />
    </div>
  );
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics when the app starts
    initGA();
  }, []);

  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <AppContent />
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
